module.exports = __webpack_public_path__ + "static/12-ed5fc02daa5ae6fca207c09177cc898f.jpg";